<div class="container-fluid">
  <div class="row">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <form>
        <div class="form-group row">
          <label>Association:</label>
          <select style=" width:70%" name="select" [(ngModel)]="addData.accountID">
            <option selected disabled>- Select Association -</option>
            <option ngDefaultControl *ngFor="let dropAcc of  insured" [ngValue]="dropAcc.id">{{dropAcc.name}}</option>
          </select>
        </div>
        <div class="form-group row">
          <label>Policy Type:</label>
          <select style=" width:40%" name="select" [(ngModel)]="addData.policyTypeID">
            <option selected disabled>- Select Type -</option>
            <option ngDefaultControl *ngFor="let dropPolT of  polTy" [ngValue]="dropPolT.id">{{dropPolT.name}}</option>

          </select>
        </div>
        <div class="form-group row">
          <label>Policy Number:</label>

          <input type="text" name="text" [(ngModel)]="addData.policyNumber">
        </div>
        <div class="form-group row">
          <label>Effective Date: </label>
          <input ngDefaultControl name="date" type="date" [(ngModel)]="addData.effectiveDate"><br>
        </div>
        <div class="form-group row">
          <label>Expiration Date: </label>
          <input ngDefaultControl name="date" type="date" [(ngModel)]="addData.expirationDate"><br>
        </div>

        <div class="form-group row">
          <label>Policy Status:</label>
          <select style=" width:40%" name="select" [(ngModel)]="addData.policyStatusID">
            <option selected disabled>- Select Status -</option>
            <option ngDefaultControl *ngFor="let dropPolS of  polS" [ngValue]="dropPolS.id">{{dropPolS.name}}</option>

          </select>
        </div>
        <div *ngIf="savingData" class="spinner-wrapper">
          <mat-spinner diameter="32" color="primary"></mat-spinner>
        </div>
        <!-- <div style="padding-top:0.5%;">
          <button style="float:right;" class="btn btn-outline-secondary" (click)="savePolicy()">
            <span *ngIf="!savingData">save</span>
            <div *ngIf="savingData" class="spinner-wrapper">
              <mat-spinner diameter="32" color="primary"></mat-spinner>
            </div>
          </button>
        </div> -->

      </form>
      
    </div>
    <div class="col-md-3"></div>
    
  </div>
  
</div>